import {firestoreAction} from "vuexfire";
import {db} from "@/plugins/db";
import * as firebase from "firebase";

export default {
    namespace: true,
    state:{
        videos: [],
        videoCategories: [],
        musical: [],
        musicalCategories: []
    },
    actions:{
        bindVideo: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef('videos', db.collection('videos').orderBy('createdAt', 'desc'))
        }),

        bindCategoryVideo: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef('videoCategories', db.collection('video-category').orderBy('createdAt', 'desc'))
        }),

        createdVideo: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('videos').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        createdCategoryVideo: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('video-category').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        // musical

        bindMusical: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef('musical', db.collection('musical').orderBy('createdAt', 'desc'))
        }),

        bindCategoryMusical: firestoreAction(({ bindFirestoreRef }) => {
            return bindFirestoreRef('musicalCategories', db.collection('musical-category').orderBy('createdAt', 'desc'))
        }),

        createdMusical: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('musical').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

        createdCategoryMusical: firestoreAction(({commit}, payload) => {
            commit('setLoading', true);
            const data: any = {
                ...payload,
                createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            };
            return db.collection('musical-category').add(data).then(() => {
                commit('setLoading', false);
            }).catch((e) => {
                commit('setLoading', false);
                alert(e)
            })
        }),

    }
}